import { render, staticRenderFns } from "./TgLiveContentCard.vue?vue&type=template&id=a4fcca28&"
import script from "./TgLiveContentCard.vue?vue&type=script&lang=js&"
export * from "./TgLiveContentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports